import React from 'react';
import * as R from 'ramda';
import {prettyDollars} from 'js/common/string_helper';
import * as ObjectHelper from 'js/common/object_helper';

const {paymentStructures, shippingPriorities, ShippingPriority, PaymentStructure} = window.sn.enums;

const findPaymentStructureText = value => R.prop('text', R.find(R.propEq('value', value), paymentStructures));

const findShippingText = value => R.prop('text', R.find(R.propEq('value', value), shippingPriorities));

const ShippingDetails = ({
    numberOfUnits,
    paymentStructure,
    productName,
    productDescription,
    productRetailCost,
    received,
    scheduledArrival,
    shippingPriority
}) => {
    const receivedVal = received ? 'Yes' : 'No';
    const arrivalDateVal = scheduledArrival || 'N/A';
    const unitsVal = numberOfUnits || 'N/A';
    const productNameVal = productName || 'N/A';
    const productDescriptionVal = productDescription || 'N/A';

    let shippingPriorityVal = 'N/A';

    // campaign launch
    if (shippingPriority && shippingPriorities) {
        shippingPriorityVal = findShippingText(shippingPriority);
    }

    // ops flow
    if (shippingPriority && ShippingPriority) {
        shippingPriorityVal = ObjectHelper.propOr('N/A', shippingPriority, ShippingPriority);
    }

    let paymentStructureVal = 'N/A';

    // campaign launch
    if (paymentStructure && paymentStructures) {
        paymentStructureVal = findPaymentStructureText(paymentStructure);
    }

    // ops flow
    if (paymentStructure && PaymentStructure) {
        paymentStructureVal = ObjectHelper.propOr('N/A', paymentStructure, PaymentStructure);
    }

    const productRetailCostVal = productRetailCost ? prettyDollars(productRetailCost, 2) : 'N/A';

    return (
        <div className="shipping-details">
            <div className="section-title">Shipping Details</div>
            <div className="shipping-details-grid">
                <div className="shipping-detail">
                    <div className="section-details-title">Has Product Been Received?</div>
                    <div className="section-details-value">{receivedVal}</div>
                </div>
                <div className="shipping-detail">
                    <div className="section-details-title">When Will Product Arrive?</div>
                    <div className="section-details-value">{arrivalDateVal}</div>
                </div>
                <div className="shipping-detail">
                    <div className="section-details-title">How Many Units?</div>
                    <div className="section-details-value">{unitsVal}</div>
                </div>
                <div className="shipping-detail">
                    <div className="section-details-title">Product Name</div>
                    <div className="section-details-value">{productNameVal}</div>
                </div>
                <div className="shipping-detail">
                    <div className="section-details-title">Product Description</div>
                    <div className="section-details-value">{productDescriptionVal}</div>
                </div>
                <div className="shipping-detail">
                    <div className="section-details-title">Product Retail Cost</div>
                    <div className="section-details-value">{productRetailCostVal}</div>
                </div>
                <div className="shipping-detail">
                    <div className="section-details-title">Shipping Priority</div>
                    <div className="section-details-value">{shippingPriorityVal}</div>
                </div>
                <div className="shipping-detail">
                    <div className="section-details-title">Payment Structure</div>
                    <div className="section-details-value">{paymentStructureVal}</div>
                </div>
            </div>
        </div>
    );
};

export default ShippingDetails;



// WEBPACK FOOTER //
// ./components/verify_receipt_common/shipping_details.js